import createStore from "astrid-helpers/src/createStore";

export const [getAnimate, setAnimate, useAnimate] = createStore(false);
